import type {
  FBSContainerListResponse,
  GASOrderHistoryResponse,
  PickupsResponse,
} from "@/shared/generated/ExpHubApi";
import { AddressType, mapToAddressTypeEnum } from "./AddressType";

type AnyApiAddress =
  | FBSContainerListResponse["containers"][number]["address"]
  | NonNullable<GASOrderHistoryResponse["orders"][number]["addresses"]>[number]
  | PickupsResponse["addresses"][number]
  | undefined;

export interface Address {
  type?: AddressType;
  name?: string;
  street?: string;
  houseNumber?: string;
  postalCode?: string;
  city?: string;
  country?: string;
}

export const mapToAddressType = (data: AnyApiAddress): Address => {
  const hasAddressType = data && "kind" in data && data.kind;
  const hasName = data && "name1" in data && data.name1;
  const hasHouseNumber = data && "streetNumber" in data && data.streetNumber;
  return {
    type: hasAddressType ? mapToAddressTypeEnum(data.kind) : undefined,
    name: hasName ? data.name1 : undefined,
    street: data?.street,
    houseNumber: hasHouseNumber ? data.streetNumber : undefined,
    postalCode: data?.postalCode,
    city: data?.city,
    country: data?.countryCode,
  };
};
